
import { Component, Vue, Watch } from 'vue-property-decorator'
import { useCultureSubsidyStore } from '@/stores/cultureSubsidy'
import { CaretakerSection } from '../types'
import StatusBadge from '../components/StatusBadge.vue'
import SectionPills from '../components/SectionPills.vue'
import OverviewPanel from './OverviewPanel.vue'
import SettingsPanel from './SettingsPanel.vue'
import FundingPanel from './FundingPanel.vue'
import HistoryPanel from './HistoryPanel.vue'
import ProductsPanel from './ProductsPanel.vue'
import OperationsPanel from './OperationsPanel.vue'
import BeneficiariesPanel from './BeneficiariesPanel.vue'

const SECTIONS: CaretakerSection[] = [
  'overview',
  'settings',
  'funding',
  'history',
  'products',
  'operations',
  'beneficiaries'
]

@Component({
  name: 'CultureSubsidy',
  components: {
    StatusBadge,
    SectionPills,
    OverviewPanel,
    SettingsPanel,
    FundingPanel,
    HistoryPanel,
    ProductsPanel,
    OperationsPanel,
    BeneficiariesPanel
  }
})
export default class extends Vue {
  store = useCultureSubsidyStore()

  get section(): CaretakerSection {
    const query = this.$route.query.section as CaretakerSection
    return SECTIONS.includes(query) ? query : 'overview'
  }

  get navItems() {
    return SECTIONS.map(id => ({
      id,
      label: String(this.$t(`cultureSubsidy.nav.${id}`)),
      badge: id === 'operations'
        ? this.store.operations.filter(operation => {
          const now = new Date()
          return new Date(`${operation.startDate}T00:00:00`) <= now && now <= new Date(`${operation.endDate}T23:59:59`)
        }).length
        : undefined
    }))
  }

  created(): void {
    this.store.loadCaretaker()
  }

  @Watch('section')
  onSection(section: CaretakerSection): void {
    this.store.caretakerSection = section
  }

  go(section: string): void {
    this.$router.replace({ query: { section } }).catch(() => undefined)
  }

  async onCommand(command: string): Promise<void> {
    if (command === 'reset') {
      await this.store.resetDemo()
      this.$message.success(this.$t('cultureSubsidy.resetDone') as string)
    }
  }
}
